export const routesConfig = [
  {
    name: 'Profile',
    translation: 'profile'
  },
  {
    name: 'CallerAuthentication',
    translation: 'callerAuthentication'
  },
  {
    name: 'AuthenticationHistory',
    translation: 'authenticationHistory'
  },
  {
    name: 'OrdersHistory',
    translation: 'ordersHistory'
  },
  {
    name: 'PickupBoxes',
    translation: 'pickupBoxes'
  },
  {
    name: 'Sensors',
    translation: 'sensors'
  },
  {
    name: 'Users',
    translation: 'users'
  },
  {
    name: 'CallbackRequests',
    translation: 'callbackRequests'
  },
  {
    name: 'CustomersFeedback',
    translation: 'customersFeedback'
  }
];

export const routesConfigChain = [
  {
    name: 'Profile',
    translation: 'profile'
  },
  {
    name: 'CustomersFeedback',
    translation: 'dashboard'
  },
  {
    name: 'Pharmacies',
    translation: 'pharmacies'
  },
  {
    name: 'Users',
    translation: 'users'
  }
];
